import "../chunks/chunk.HAL7R4WT.js";
import {
  registerIconLibrary,
  unregisterIconLibrary
} from "../chunks/chunk.3WAW4E2K.js";
import "../chunks/chunk.P7ZG6EMR.js";
import "../chunks/chunk.VRTJZYIC.js";
import "../chunks/chunk.3Y6SB6QS.js";
import "../chunks/chunk.MAD5PUM2.js";
export {
  registerIconLibrary,
  unregisterIconLibrary
};
